import { render, staticRenderFns } from "./TicketDetails.vue?vue&type=template&id=65e90faa&"
import script from "./TicketDetails.vue?vue&type=script&lang=js&"
export * from "./TicketDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e90faa')) {
      api.createRecord('65e90faa', component.options)
    } else {
      api.reload('65e90faa', component.options)
    }
    module.hot.accept("./TicketDetails.vue?vue&type=template&id=65e90faa&", function () {
      api.rerender('65e90faa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Support/TicketSingle/TicketDetails.vue"
export default component.exports